import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Wrapper from "../Layout/Wrapper";
import firebase from "firebase";

const TopBarWrapper = styled.div`
  height: 32px;
  border-bottom: 2px solid #fafafa;
  nav {
    display: flex;
    height: 100%;
    align-items: center;
    a {
      font-size: 14px;
      text-transform: uppercase;
      margin-right: 32px;
      text-decoration: none;
      color: #666666;
      font-weight: bold;
      &.active,
      &:hover {
        color: var(--orange);
      }
    }
  }

  .right {
    display: flex;
  }
`;

const TopBar = () => {
  return (
    <TopBarWrapper>
      <Wrapper style={{ justifyContent: "space-between" }}>
        <nav>
          <NavLink to="/admin">Calendar</NavLink>
          <NavLink to="/admin/activities">Activities</NavLink>
          <NavLink to="/admin/sessions">Lessons</NavLink>

          <NavLink to="/admin/students">Students</NavLink>
          <NavLink to="/admin/classes">Classes</NavLink>
          <NavLink to="/leaderboard">Leaderboard</NavLink>
          <NavLink to="/profile">Your Profile</NavLink>
          {/* <NavLink to="/admin/admins">Admins</NavLink> */}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            onClick={(e) => {
              e.preventDefault();
              firebase
                .auth()
                .signOut()
                .then(() => {
                  window.location.reload();
                });
            }}
          >
            Logout
          </a>
        </nav>
      </Wrapper>
    </TopBarWrapper>
  );
};

export default TopBar;
